import React, { memo, useContext, useEffect, useState } from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import LcaReport from "./PieChartDataHandler.component";

const COLORS = ["#16BFD6", "#F765A3", "#A155B9", "#F78965","#4CAF50","#FFC107"];

// const RADIAN = Math.PI / 180;
// const renderCustomizedLabel = ({
//   cx,
//   cy,
//   midAngle,
//   innerRadius,
//   outerRadius,
//   percent,
//   name,
// }: any) => {
//   const radius = innerRadius + (outerRadius - innerRadius) * 1.2;
//   const x = cx + radius * Math.cos(-midAngle * RADIAN);
//   const y = cy + radius * Math.sin(-midAngle * RADIAN);

//   return (
//     <text
//       x={x}
//       y={y}
//       fill="black"
//       textAnchor={x > cx ? "start" : "end"}
//       dominantBaseline="central"
//       fontSize={14}
//       fontWeight="bold"
//     >
//       {`${name}: ${(percent * 100).toFixed(0)}%`}
//     </text>
//   );
// };

const DataPieChart = ({data}:any) => {
  const [materialEmbodied, setMaterialEmbodied] = useState<number>(0);
  const [transportEmbodied, setTransportEmbodied] = useState<number>(0);
  const [production, setProductionEmbodied] = useState<number>(0);
  const [transport, setTransport] = useState<number>(0);
  const [packageCal, setPackageCal] = useState<number>(0);
  const [disposal, setDisposal] = useState<number>(0);

  useEffect(() => {
    if (data) {
      setMaterialEmbodied( data?.materialOfComponent || 0);
      setTransportEmbodied( data?.transportOfComponent || 0);
      setProductionEmbodied( data?.processFactoryCo2 || 0);
      setTransport(data?.journeyTransportCo2 || 0);
      setPackageCal(data?.totalPackagingCo2 || 0);
      setDisposal(data?.totalDisposalCo2 || 0);
    }
  }, [data]);

  // Create chart data using state values
  const chartData = [
    { name: "Embodied Materials", value: materialEmbodied },
    { name: "Upstream Transport", value: transportEmbodied },
    { name: "Production", value: production },
    { name: "Transport", value: transport },
    { name: "Packaging", value: packageCal },
    { name: "Disposal", value: disposal }
  ];

  return (
    <div style={{ textAlign: "center",display:'flex',alignItems:'center',flexDirection:'column' }}>
      <PieChart width={300} height={300}>
        <Pie
          data={chartData}
          cx={150}
          cy={150}
          labelLine={true}
        //   label={renderCustomizedLabel}
          outerRadius={100}
          fill="#8884d8"
          dataKey="value"
        >
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        {/* Tooltip to show name and value on hover */}
        <Tooltip formatter={(value, name) => [`${value}`, `${name}`]} />
      </PieChart>

      {/* Custom Legend Below Chart */}
      <LcaReport data={chartData} colors={COLORS} />
    </div>
  );
}
export default memo(DataPieChart);
